"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRedirectUserToTermsPageSuccess = exports.shouldRedirectUserToTermsPageFailure = exports.shouldRedirectUserToTermsPage = exports.fetchRegionsFailed = exports.fetchRegionsSuccess = exports.fetchRegionsRequest = exports.SubmitFirstLoginRequest = exports.submitFirstLoginFailure = exports.submitFirstLoginSuccess = exports.setCompany = exports.setUserLanguage = exports.setUserAvatar = exports.updateField = exports.setUserData = exports.acceptMarketingConsent = exports.acceptTerms = exports.changeAcceptTerms = exports.validateStepSuccess = exports.validateStepFailure = exports.changeStep = void 0;
const Actions = require("../../actionTypes/firstLogin/form");
const changeStep = (page) => ({
    type: Actions.CHANGE_STEP,
    payload: {
        page
    }
});
exports.changeStep = changeStep;
const validateStepFailure = (errors) => ({
    type: Actions.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = (page) => ({
    type: Actions.VALIDATE_STEP_SUCCESS,
    payload: {
        page
    }
});
exports.validateStepSuccess = validateStepSuccess;
const changeAcceptTerms = (hasAcceptedTerms) => ({
    type: Actions.CHANGE_ACCEPT_TERMS,
    payload: {
        hasAcceptedTerms
    }
});
exports.changeAcceptTerms = changeAcceptTerms;
const acceptTerms = (hasAcceptedTerms, termsVersion) => ({
    type: Actions.ACCEPT_TERMS,
    payload: {
        hasAcceptedTerms,
        termsVersion
    }
});
exports.acceptTerms = acceptTerms;
const acceptMarketingConsent = (hasAcceptedMarketingConsent) => ({
    type: Actions.ACCEPT_MARKETING_CONSENT,
    payload: {
        hasAcceptedMarketingConsent
    }
});
exports.acceptMarketingConsent = acceptMarketingConsent;
const setUserData = (userData) => ({
    type: Actions.SET_USER_DATA,
    payload: userData
});
exports.setUserData = setUserData;
const updateField = (field, value) => ({
    type: Actions.UPDATE_USER_DATA,
    payload: {
        field,
        value
    }
});
exports.updateField = updateField;
const setUserAvatar = (avatar) => ({
    type: Actions.SET_USER_AVATAR,
    payload: {
        avatar
    }
});
exports.setUserAvatar = setUserAvatar;
const setUserLanguage = (language) => ({
    type: Actions.SET_USER_LANGUAGE,
    payload: {
        language
    }
});
exports.setUserLanguage = setUserLanguage;
const setCompany = (customerId) => ({
    type: Actions.SET_COMPANY,
    payload: customerId
});
exports.setCompany = setCompany;
function submitFirstLoginSuccess() {
    return {
        type: Actions.SUBMIT_FIRST_LOGIN_SUCCESS
    };
}
exports.submitFirstLoginSuccess = submitFirstLoginSuccess;
function submitFirstLoginFailure(error) {
    return {
        type: Actions.SUBMIT_FIRST_LOGIN_FAILED,
        payload: error
    };
}
exports.submitFirstLoginFailure = submitFirstLoginFailure;
const SubmitFirstLoginRequest = (payload) => ({
    type: Actions.SUBMIT_FIRST_LOGIN_REQUEST,
    payload
});
exports.SubmitFirstLoginRequest = SubmitFirstLoginRequest;
const fetchRegionsRequest = () => ({
    type: Actions.FETCH_REGIONS_REQUEST
});
exports.fetchRegionsRequest = fetchRegionsRequest;
const fetchRegionsSuccess = (list) => ({
    type: Actions.FETCH_REGIONS_SUCCESS,
    payload: list
});
exports.fetchRegionsSuccess = fetchRegionsSuccess;
const fetchRegionsFailed = (error) => ({
    type: Actions.FETCH_REGIONS_FAILED,
    payload: error
});
exports.fetchRegionsFailed = fetchRegionsFailed;
const shouldRedirectUserToTermsPage = () => ({
    type: Actions.SHOULD_REDIRECT_USER_TO_TERMS_PAGE
});
exports.shouldRedirectUserToTermsPage = shouldRedirectUserToTermsPage;
const shouldRedirectUserToTermsPageFailure = (payload) => ({
    type: Actions.SHOULD_REDIRECT_USER_TO_TERMS_PAGE_FAILURE
});
exports.shouldRedirectUserToTermsPageFailure = shouldRedirectUserToTermsPageFailure;
const shouldRedirectUserToTermsPageSuccess = (message) => ({
    type: Actions.SHOULD_REDIRECT_USER_TO_TERMS_PAGE_SUCCESS,
    payload: {
        message
    }
});
exports.shouldRedirectUserToTermsPageSuccess = shouldRedirectUserToTermsPageSuccess;
//# sourceMappingURL=form.js.map